export default {
  "User Interface": {
    title: "User Interface",
    description:
      "User interface (UI) design is the process of building interfaces for software or digital devices. UI focuses on the look and feel of the product and at the same time complements the entire user experience.",
    links: [
      {
        iconType: "article",
        title: "What is User Interface Design?",
        href: "https://www.interaction-design.org/literature/topics/ui-design",
      },
      {
        iconType: "article",
        title: "A Comprehensive Guide To UI Design",
        href: "https://www.smashingmagazine.com/2018/02/comprehensive-guide-ui-design/",
      },
      {
        iconType: "article",
        title: "8 Best Practices For UI Card Design",
        href: "https://medium.com/user-experience-design-1/8-best-practices-for-ui-card-design-898f45bb60cc",
      },
      {
        iconType: "video",
        title: "UX Design vs UI Design - What's The Difference?",
        href: "https://www.youtube.com/watch?v=5CxXhyhT6Fc",
      },

      {
        iconType: "article",
        title: "Learn UI Design Blog",
        href: "https://www.learnui.design/blog/",
      },
      {
        iconType: "book",
        title: "Universal Principles of Design",
        href: "https://www.amazon.com/Universal-Principles-Design-Revised-Updated/dp/1592535879/ref=sr_1_2?crid=2SUZVNW2CCA53&keywords=universal+principles+of+design&qid=1655150221&sprefix=universal+principle%2Caps%2C94&sr=8-2",
      },
    ],
  },
  "Design Handoff": {
    title: "Design Handoff",
    description:
      "Design handoff is the process of handing over designs to the developer team that takes place when UI designs reach the development stage. At this phase, close collaboration between designers and developers is the key factor that defines a smooth implementation workflow.",
    links: [
      {
        iconType: "article",
        title: "How to Ensure a Smooth Design Handoff",
        href: "https://www.interaction-design.org/literature/article/how-to-ensure-a-smooth-design-handoff",
      },
      {
        iconType: "article",
        title:
          "Design Handoff Guide: What Makes Good Designer-Developer Collaboration?",
        href: "https://uxstudioteam.com/ux-blog/design-handoff/",
      },
      {
        iconType: "video",
        title:
          "Design & Engineering Collaboration with Uber Engineer Faraz Ahmad",
        href: "https://www.youtube.com/watch?v=gtzriWbG48I",
      },
    ],
  },
  "Atomic Design": {
    title: "Atomic Design",
    description:
      "Atomic Design is a methodology created by Brad Frost seeking to provide direction on building interface design systems more deliberately and with explicit order and hierarchy.",
    links: [
      {
        iconType: "article",
        title: "Atomic Design | Blog",
        href: "https://bradfrost.com/blog/post/atomic-web-design/",
      },
      {
        iconType: "book",
        title: "Atomic Design by Brad Frost",
        href: "https://atomicdesign.bradfrost.com/",
      },
      {
        iconType: "article",
        title: "Atomic Design Principles & Methodology 101",
        href: "https://xd.adobe.com/ideas/process/ui-design/atomic-design-principles-methodology-101/",
      },
    ],
  },

  "Design Systems": {
    title: "Design System",
    description:
      "Design system is the library of guidelines and reusable components that should establish the consistency of the product experience. The goal of a design system is to create a single source of truth, that is visible and maintainable by the team.",
    links: [
      {
        iconType: "article",
        title: "What is a Design System? A simple guide to get started",
        href: "https://medium.com/user-experience-design-1/what-is-a-design-system-a-simple-guide-to-get-started-529fb4b38f9b",
      },
      {
        iconType: "article",
        title: "Creating a design system in Figma: a practical guide",
        href: "https://uxdesign.cc/creating-a-design-system-in-figma-cbd01b0d2424",
      },
      {
        iconType: "article",
        title:
          "The Benefits of a Design System: Making Better Products, Faster",
        href: "https://www.toptal.com/designers/design-systems/benefits-of-design-system",
      },
      {
        iconType: "article",
        title: "A collection of Design Systems for Figma",
        href: "https://www.designsystemsforfigma.com/",
      },
      {
        iconType: "video",
        title: "Build it in Figma: Create a Design System — Foundations",
        href: "https://www.youtube.com/watch?v=EK-pHkc5EL4",
      },
      {
        iconType: "book",
        title: "Design Systems by Alla Kholmatova (Hardcover Print + eBook)",
        href: "https://shop.smashingmagazine.com/products/design-systems-by-alla-kholmatova?_ga=2.158805882.1384829527.1659014325-261602594.1656328434",
      },
    ],
  },
  "Color Palette": {
    title: "Color Palette",
    description:
      "Color palette is a set of colors that work well together to establish visual harmony and create consistency in a product.",
    links: [
      {
        iconType: "article",
        title: "48+ Best Color Tools for Designers to Improve Your Workflow",
        href: "https://en.eagle.cool/blog/post/best-color-tools-for-designers",
      },
      {
        iconType: "article",
        title: "Creating A Design System: Building a Color Palette",
        href: "https://www.uxpin.com/create-design-system-guide/build-color-palette-for-design-system",
      },
      {
        iconType: "article",
        title: "Color theory for designers — a crash course (with infographic)",
        href: "https://uxdesign.cc/color-theory-for-designers-a-crash-course-with-infographic-41d8b4c45619",
      },
      {
        iconType: "article",
        title: "Capture Attention Through Color Psychology",
        href: "https://www.uxmatters.com/mt/archives/2020/02/capture-attention-through-color-psychology.php",
      },
      {
        iconType: "article",
        title: "A quick guide to choosing a color palette",
        href: "https://www.invisionapp.com/inside-design/quick-guide-color-palette/",
      },
      {
        iconType: "video",
        title: "How to Choose Colors (Easy 3-Step Process)",
        href: "https://www.youtube.com/watch?v=KMS3VwGh3HY",
      },
    ],
  },
  Typography: {
    title: "Typography",
    description:
      "Typography is crucial for establishing a visual hierarchy and expressing a product's brand. In a design system typography sets a foundation of fonts, type scales, and weights.",
    links: [
      {
        iconType: "article",
        title: "Typography in UI Design",
        href: "https://xd.adobe.com/ideas/process/ui-design/typography-in-ui-design/",
      },

      {
        iconType: "video",
        title: "Typography Tutorial - 10 rules to help you rule type",
        href: "https://www.youtube.com/watch?v=QrNi9FmdlxY",
      },

      {
        iconType: "article",
        title: "The typographic scale",
        href: "https://spencermortensen.com/articles/typographic-scale/",
      },

      {
        iconType: "article",
        title: "10 Principles for Typography in UI Design",
        href: "https://uxdesign.cc/10-principles-for-typography-usage-in-ui-design-a8f038f43ffd",
      },
      {
        iconType: "article",
        title: "Typography in Design Systems",
        href: "https://medium.com/eightshapes-llc/typography-in-design-systems-6ed771432f1e",
      },
      {
        iconType: "article",
        title: "12 Helpful Typography Tools",
        href: "https://uxplanet.org/12-helpful-typography-tools-ea0d808eb70b",
      },
    ],
  },

  "Grids & Spacings": {
    title: "Grids & Spacings",
    description:
      "Grids and spatial systems are the foundation of a consistent layout. Grids help arrange content in a structured way while a spatial system defines the rules of sizing and spacing.",
    links: [
      {
        iconType: "article",
        title: "Space, Grids, and Layouts",
        href: "https://www.designsystems.com/space-grids-and-layouts/",
      },
      {
        iconType: "article",
        title: "Intro to The 8-Point Grid System",
        href: "https://medium.com/built-to-adapt/intro-to-the-8-point-grid-system-d2573cde8632",
      },
      {
        iconType: "article",
        title: "Responsive grids and how to actually use them",
        href: "https://uxdesign.cc/responsive-grids-and-how-to-actually-use-them-970de4c16e01",
      },
      {
        iconType: "book",
        title: "Grid Systems in Graphic Design",
        href: "https://www.amazon.com/Grid-systems-graphic-design-communication/dp/3721201450",
      },
    ],
  },
  Iconography: {
    title: "Iconography",
    description:
      "Icons visually express objects, actions, and ideas. If used in a correct way, they communicate the core idea and intent of a product or action.",
    links: [
      {
        iconType: "article",
        title: "Icons As Part Of A Great User Experience",
        href: "https://www.smashingmagazine.com/2016/10/icons-as-part-of-a-great-user-experience/",
      },
      {
        iconType: "article",
        title: "A complete guide to iconography",
        href: "https://www.designsystems.com/iconography-guide/",
      },
      {
        iconType: "article",
        title: "Design System: Icons",
        href: "https://uxplanet.org/design-system-icons-5955b68eb3dd",
      },
      {
        iconType: "article",
        title: "Iconography by Atlassian",
        href: "https://atlassian.design/foundations/iconography",
      },
    ],
  },
  Components: {
    title: "Components",
    description:
      "Components are reusable building blocks of the user interface. Each component meets a particular UI need and it's specifically created to work together with other components to create patterns, templates, and pages.",
    links: [
      {
        iconType: "article",
        title: "How we Build a Component Design System",
        href: "https://blog.bitsrc.io/how-we-build-our-design-system-15713a1f1833",
      },
      {
        iconType: "article",
        title: "Consistency Is Key – How to Build a Figma Design System",
        href: "https://www.toptal.com/designers/figma/figma-design-system",
      },
      {
        iconType: "video",
        title: "Build it in Figma: Create a design system — Components",
        href: "https://www.youtube.com/watch?v=9xUXTFzDDCo",
      },
      {
        iconType: "video",
        title:
          "Design System Naming Conventions - A Practical Guide - Florian Gampert at Into Design Systems",
        href: "https://www.youtube.com/watch?v=w2LFfOtPsoc",
      },
    ],
  },
  "UI Patterns": {
    title: "UI Patterns",
    description:
      "User Interface Design patterns are existing solutions that are used for common design problems.",
    links: [
      {
        iconType: "article",
        title: "User Interface Design Patterns",
        href: "https://ui-patterns.com/patterns",
      },
      {
        iconType: "article",
        title: "UI design inspirations",
        href: "https://screenlane.com/",
      },
      {
        iconType: "article",
        title: "Mobbin: Collection of mobile apps for UI & UX research",
        href: "https://mobbin.com/browse/ios/apps",
      },
    ],
  },

  "Design Principles": {
    title: "Design Principles",
    description:
      "Design principles are a set of guidelines that support consistency in decision-making across teams working on the same product or service.",
    links: [
      {
        iconType: "article",
        title: "An open source collection of Design Principles and methods.",
        href: "https://principles.design/",
      },
      {
        iconType: "article",
        title:
          "Crafting Product-Specific Design Principles to Support Better Decision Making.",
        href: "https://www.nngroup.com/articles/design-principles/",
      },
      {
        iconType: "book",
        title: "Universal Principles of Design",
        href: "https://www.amazon.com/Universal-Principles-Design-Revised-Updated/dp/1592535879/ref=sr_1_2?crid=2SUZVNW2CCA53&keywords=universal+principles+of+design&qid=1655150221&sprefix=universal+principle%2Caps%2C94&sr=8-2",
      },
    ],
  },
  Documentation: {
    title: "Documentation",
    description:
      "Documentation is the part of a design system that consists of a set of guidelines that helps developers, designers, project managers, and other stakeholders ship consistent UIs.",
    links: [
      {
        iconType: "article",
        title: "4 ways to document your design system with Storybook",
        href: "https://storybook.js.org/blog/4-ways-to-document-your-design-system-with-storybook/",
      },
      {
        iconType: "article",
        title: "7 Great Design System Management Tools",
        href: "https://www.uxpin.com/studio/blog/7-great-design-system-management-tools/",
      },
    ],
  },

  "UI Animation": {
    title: "UI Animation",
    description:
      "Animations bring the interface to life. It helps to inform a user about state changes, reinforces the hierarchy of UI elements, directs a user’s focus to the right spot at the right time, and as a result enriches the overall user experience.",
    links: [
      {
        iconType: "article",
        title: "Animation principles in UI",
        href: "https://www.invisionapp.com/inside-design/animation-principles-in-ui/",
      },
      {
        iconType: "article",
        title: "Animation Principles for UX Designers",
        href: "https://xd.adobe.com/ideas/principles/human-computer-interaction/animation-principles-for-ux-designers/",
      },
      {
        iconType: "article",
        title: "Collection of Animation Articles & Tools",
        href: "https://valhead.com/ui-animation/",
      },
      {
        iconType: "book",
        title: "Animation Handbook by Ryan McLeod",
        href: "https://s3.amazonaws.com/designco-web-assets/uploads/2019/05/animationhandbook.pdf",
      },
      {
        iconType: "article",
        title: "Aninix · UI animation in Figma",
        href: "https://www.figma.com/community/plugin/988173868842375596/Aninix-%C2%B7-UI-animation",
      },
    ],
  },
  "Micro-interactions": {
    title: "Micro-interactions",
    description:
      "Micro-interactions are small, functional animations that provide a user with visual feedback and display changes more clearly.",
    links: [
      {
        iconType: "article",
        title:
          "Micro-interactions: why, when and how to use them to improve the user experience",
        href: "https://uxdesign.cc/micro-interactions-why-when-and-how-to-use-them-to-boost-the-ux-17094b3baaa0",
      },
      {
        iconType: "article",
        title: "Microinteractions in User Experience",
        href: "https://www.nngroup.com/articles/microinteractions/",
      },
      {
        iconType: "video",
        title:
          "Motion Design with Figma: Animations, Motion Graphics, UX/UI (Udemy)",
        href: "https://www.udemy.com/course/motion-design-with-figma-animations-motion-graphics-uxui/",
      },
      {
        iconType: "article",
        title: "Figma: 5 ways to add animation to your designs",
        href: "https://uxdesign.cc/figma-5-ways-to-add-animation-to-your-designs-e3c521aa8902",
      },
      {
        iconType: "article",
        title: "10 microinteractions that will inspire your next project",
        href: "https://www.invisionapp.com/inside-design/10-microinterations-that-will-inspire-your-next-project/",
      },
    ],
  },

  "Design Tools": {
    title: "Design Tools",
    description:
      "Design tools provide a designer with the enviroment to create digital user interfaces. In order to establish and simplify overlall design workflow, it is important to have reliable UI design tools and keep track of the latest tool's updates.",
    links: [
      {
        iconType: "article",
        title: "10 Figma Best Practices to 10X Your Workflow",
        href: "https://uxdesign.cc/10-figma-best-practices-to-10x-your-workflow-76d6336daf2a",
      },
      {
        iconType: "article",
        title: "Must-Have Figma Plugins to Boost Your Design Workflow",
        href: "https://medium.com/codeart-mk/must-have-figma-plugins-to-boost-your-design-workflow-4592ce4dd640",
      },
      {
        iconType: "article",
        title: "The 9 best prototyping tools for UI/UX designers in 2022",
        href: "https://www.uxdesigninstitute.com/blog/best-prototyping-tools-for-ux-designers/",
      },
      {
        iconType: "article",
        title: "20 Design Tools Survey",
        href: "https://uxtools.co/survey-2021/ ",
      },
    ],
  },

  "Usability Principles": {
    title: "Usability Principles",
    description: `Usability principles are a set of basic guidelines or "heuristics" that defines how to create good product usability and make sure that the interface is easy-to-use.`,
    links: [
      {
        iconType: "article",
        title: "What is Usability",
        href: "https://www.interaction-design.org/literature/topics/usability",
      },
      {
        iconType: "article",
        title: "10 Usability Heuristics for User Interface Design",
        href: "https://www.nngroup.com/articles/ten-usability-heuristics/",
      },
      {
        iconType: "article",
        title: "Dieter Rams: 10 Timeless Commandments for Good Design",
        href: "https://www.interaction-design.org/literature/article/dieter-rams-10-timeless-commandments-for-good-design",
      },
      {
        iconType: "article",
        title: "Bad Design vs. Good Design: 5 Examples We can Learn From",
        href: "https://www.interaction-design.org/literature/article/bad-design-vs-good-design-5-examples-we-can-learn-frombad-design-vs-good-design-5-examples-we-can-learn-from-130706",
      },
    ],
  },
  "Usability Issues": {
    title: "Usability Issues",
    description:
      "Usability issues are common usability mistakes that could negatively affect the overall user experience.",
    links: [
      {
        iconType: "article",
        title: "10 Common Mistakes UI Designers Make",
        href: "https://uxdesign.cc/10-common-mistakes-ui-designers-make-7c95bb5436b5",
      },
      {
        iconType: "article",
        title: "The Impact of Usability on the Cost of Quality",
        href: "https://www.researchgate.net/publication/280742273_The_impact_of_usability_on_the_cost_of_quality",
      },
      {
        iconType: "article",
        title: "10 Key Mobile Usability Issues",
        href: "https://uxplanet.org/10-key-mobile-usability-issues-7029b8efe119",
      },
      {
        iconType: "article",
        title: "7 Usability Mistakes That Are Hurting Your Brand",
        href: "https://www.brandextract.com/Insights/Articles/7-Usability-Mistakes-That-Are-Hurting-Your-Brand/",
      },
      {
        iconType: "video",
        title: "Top 10 Web-Design Mistakes by NNgroup",
        href: "https://www.youtube.com/watch?v=VGxze7xMYJs",
      },
      {
        iconType: "video",
        title: "5 Most Common Web Design Mistakes to Avoid",
        href: "https://www.youtube.com/watch?v=uIoatHd7GW4",
      },
    ],
  },
  "Accessible Design": {
    title: "Accessible Design",
    description:
      "Accessible design refers to the practice of ensuring that the design of products, services, and facilities can be independently used by people with a variety of disabilities.",
    links: [
      {
        iconType: "article",
        title: "What is Accessibility?",
        href: "https://www.interaction-design.org/literature/topics/accessibility",
      },

      {
        iconType: "article",
        title: "A guide to color accessibility in product design",
        href: "https://www.invisionapp.com/inside-design/color-accessibility-product-design/",
      },
      {
        iconType: "article",
        title: "Color Contrast for Better Readability",
        href: "https://www.viget.com/articles/color-contrast/",
      },
      {
        iconType: "article",
        title: "How to Design an Accessible Color Scheme",
        href: "https://medium.com/envoy-design/how-to-design-an-accessible-color-scheme-4a13ca12c92b",
      },

      {
        iconType: "video",
        title: "Accessible Web Design: What Is It & How To Do It",
        href: "https://www.youtube.com/watch?v=-ao_Kc_8rpE",
      },
    ],
  },
  "Inclusive Design": {
    title: "Inclusive Design",
    description:
      "Inclusive design describes methodologies for creating products that are understandable and accessible by people of all backgrounds and abilities. It may address accessibility, age, economic situation, geographic location, language, race, and more.",
    links: [
      {
        iconType: "article",
        title: "Inclusive Design",
        href: "https://www.nngroup.com/articles/inclusive-design/",
      },
      {
        iconType: "article",
        title: "Accessible Design vs. Inclusive Design (with Infographic)",
        href: "https://www.toptal.com/designers/ui/inclusive-design-infographic",
      },
      {
        iconType: "article",
        title: "6 Principles for Inclusive Design",
        href: "https://uxplanet.org/6-principles-for-inclusive-design-3e9867f7f63e",
      },
      {
        iconType: "article",
        title: "Inclusive Design: An Overview of Current Thinking",
        href: "https://www.uxmatters.com/mt/archives/2019/08/inclusive-design-an-overview-of-current-thinking.php",
      },

      {
        iconType: "article",
        title: "Inclusive Design by Microsoft",
        href: "https://www.microsoft.com/design/inclusive/",
      },
    ],
  },
  "Tools & Checklist": {
    title: "Tools & Checklist",
    description:
      "Web accessibility evaluation tools are online services that help to determine if web content meets accessibility guidelines.",
    links: [
      {
        iconType: "article",
        title: "Accessibility tools for designers and developers",
        href: "https://uxdesign.cc/accessibility-tools-for-designers-and-developers-ea400a415c0a",
      },

      {
        iconType: "article",
        title: "WCAG Compliance Checklist by A11Y",
        href: "https://www.a11yproject.com/checklist/",
      },
      {
        iconType: "article",
        title: "8 tools that make accessible design easier",
        href: "https://www.invisionapp.com/inside-design/accessibility-tools/",
      },
    ],
  },
  "Mobile App Design": {
    title: "Mobile App Design",
    description:
      "Mobile app design is the process of creating user interfaces for mobile devices with the consideration of the user's needs, constraints, and platform guidelines.",
    links: [
      {
        iconType: "article",
        title: "A Comprehensive Guide To Mobile App Design",
        href: "https://www.smashingmagazine.com/2018/02/comprehensive-guide-to-mobile-app-design/",
      },
      {
        iconType: "article",
        title:
          "Mobile UX Design Constraints, Best Practices, and Working With Developers",
        href: "https://www.toptal.com/designers/ux/mobile-ux-design-best-practices",
      },

      {
        iconType: "article",
        title:
          "Principles of Mobile App Design: Engage Users and Drive Conversions",
        href: "https://www.thinkwithgoogle.com/future-of-marketing/creativity/principles-of-mobile-app-design-engage-users-and-drive-conversions/",
      },

      {
        iconType: "article",
        title: "Mobile app design - Invision",
        href: "https://www.invisionapp.com/defined/mobile-app-design",
      },
    ],
  },
  "iOS & Android": {
    title: "iOS & Android",
    description:
      "Designing for iOS and Android are different, this is why it's important to consider the platform's guidelines and best practices for each platform individually.",
    links: [
      {
        iconType: "article",
        title: "iOS vs. Android App UI Design: The Complete Guide",
        href: "https://www.learnui.design/blog/ios-vs-android-app-ui-design-complete-guide.html",
      },
      {
        iconType: "article",
        title: "Human Interface Guidelines - Design - Apple Developer",
        href: "https://developer.apple.com/design/human-interface-guidelines/guidelines/overview/",
      },
      {
        iconType: "article",
        title: "2022 winners and finalists - Apple Design Awards",
        href: "https://developer.apple.com/design/awards/",
      },
      {
        iconType: "article",
        title: "Material Design",
        href: "https://material.io/design",
      },
      {
        iconType: "article",
        title: "UX best practices for apps on Google Play Instant ",
        href: "https://developer.android.com/topic/google-play-instant/best-practices/apps",
      },
      {
        iconType: "article",
        title: "Accessibility in iOS design",
        href: "https://developer.apple.com/design/human-interface-guidelines/foundations/accessibility",
      },
      {
        iconType: "article",
        title: "SwiftUI Accessibility: Semantic Views",
        href: "https://medium.com/@r.whitaker/swiftui-accessibility-semantic-views-1f0dea3b9602",
      },
      {
        iconType: "article",
        title: "Checklist: How to make your iOS app more accessible",
        href: "https://www.hackingwithswift.com/articles/91/checklist-how-to-make-your-ios-app-more-accessible",
      },
    ],
  },
  "Mobile UI Patterns": {
    title: "Mobile UI Patterns",
    description:
      "Mobile UI Patterns is a collection of UI/UX Patterns that can be used as a reference for decision-making of common design problems.",
    links: [
      {
        iconType: "article",
        title: "Mobbin: Collection of mobile apps for UI & UX research",
        href: "https://mobbin.com/browse/ios/apps",
      },
      {
        iconType: "article",
        title: "UXArchive: Library of mobile user flows",
        href: "https://uxarchive.com/",
      },
      {
        iconType: "article",
        title: "13 basic mobile UI patterns to know about",
        href: "https://uxdesign.cc/mobile-ui-13-basic-patterns-of-app-ui-design-to-know-about-d3f7c6176f13",
      },
    ],
  },
  "HTML & CSS": {
    title: "HTML & CSS",
    description:
      "HTML is the foundation of all web pages. It defines the structure of a page, while CSS defines its style. Good knowledge of HTML and CSS helps a designer to be aligned with a development team regarding terminology, layer name conventions, responsiveness, and other important aspects of front-end development.",
    links: [
      {
        iconType: "video",
        title: "HTML and CSS Tutorial for 2021",
        href: "https://www.youtube.com/watch?v=D-h8L5hgW-w&t=1s",
      },
      {
        iconType: "video",
        title: "Learn HTML5 and CSS3 From Scratch - Full Course",
        href: "https://www.youtube.com/watch?v=mU6anWqZJcc",
      },
      {
        iconType: "video",
        title: "Build Responsive Real-World Websites with HTML and CSS (Udemy)",
        href: "https://www.udemy.com/course/design-and-develop-a-killer-website-with-html5-and-css3/",
      },
    ],
  },
  "Responsive Layouts": {
    title: "Responsive Layouts",
    description:
      "Responsive design is the design approach used to create a UI that adjusts smoothly to various screen sizes. Designers are responsible for making sure that a product is usable and accessible on all devices.",
    links: [
      {
        iconType: "article",
        title: "Responsive grids and how to actually use them",
        href: "https://uxdesign.cc/responsive-grids-and-how-to-actually-use-them-970de4c16e01",
      },
      {
        iconType: "article",
        title: "Responsive Web Design: What It Is And How To Use It",
        href: "https://www.smashingmagazine.com/2011/01/guidelines-for-responsive-web-design/",
      },

      {
        iconType: "video",
        title: "Introduction To Responsive Web Design - HTML & CSS Tutorial",
        href: "https://www.youtube.com/watch?v=srvUrASNj0s",
      },
      {
        iconType: "video",
        title: "Responsive CSS Grid Tutorial",
        href: "https://www.youtube.com/watch?v=68O6eOGAGqA",
      },
    ],
  },
};
